module.exports = __webpack_public_path__ + "static/media/video.ddfd20c4.mp4";